import { render, staticRenderFns } from "./PostsIndex.vue?vue&type=template&id=37d78a92"
import script from "./PostsIndex.vue?vue&type=script&lang=js"
export * from "./PostsIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports